import { Controller, ActionEvent } from "@hotwired/stimulus";
export default class extends Controller {

  static targets = ["areaRestricted", "areaRestrictedOptions", "areaRestrictedOption", "suburbRestricted", "suburbRestrictedOptions", "storeSelect", "tagSelect"];

  declare hasAreaRestrictedTarget: boolean;
  declare hasSuburbRestrictedTarget: boolean;
  declare hasStoreSelectTarget: boolean;
  declare hasTagSelectTarget: boolean;
  declare areaRestrictedTarget: HTMLInputElement;
  declare areaRestrictedOptionsTargets: HTMLElement[];
  declare areaRestrictedOptionTargets: HTMLInputElement[];
  declare suburbRestrictedTarget: HTMLInputElement;
  declare suburbRestrictedOptionsTargets: HTMLElement[];
  declare storeSelectTarget: HTMLSelectElement;
  declare tagSelectTarget: HTMLSelectElement;

  connect(): void {
    if (this.hasAreaRestrictedTarget && this.hasSuburbRestrictedTarget) {
      this.applyLocationFilters();
    }
  }

  adjustStoreSelect(event: ActionEvent) {
    event.preventDefault();

    const interpolatedNewTurboSourceUrl = event.params.url as string
    const applicableCouponsFrame = document.getElementById("applicable_coupon_products_frame")
    const requiredCouponsFrame = document.getElementById("required_coupon_products_frame")

    if (this.hasStoreSelectTarget && this.storeSelectTarget.value !== "") {
      this.tagSelectTarget.value = "";
      applicableCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restaurant_id=${this.storeSelectTarget.value}`);
      requiredCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restaurant_id=${this.storeSelectTarget.value}`);
    } else {
      applicableCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restaurant_id=all_stores`);
      requiredCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restaurant_id=all_stores`);
    }
  }

  adjustRestaurantTag(event: ActionEvent) {
    event.preventDefault();
    const interpolatedNewTurboSourceUrl = event.params.url as string
    const requiredCouponsFrame = document.getElementById("required_coupon_products_frame")
    const applicableCouponsFrame = document.getElementById("applicable_coupon_products_frame")

    if (this.hasTagSelectTarget && this.tagSelectTarget.value !== "") {
      this.storeSelectTarget.value = "";
      requiredCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restricted_to_tag_id=${this.tagSelectTarget.value}`);
      applicableCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restricted_to_tag_id=${this.tagSelectTarget.value}`);
    } else {
      requiredCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restricted_to_tag_id=all_stores`);
      applicableCouponsFrame?.setAttribute("src", `${interpolatedNewTurboSourceUrl}?restricted_to_tag_id=all_stores`);
    }
  }

  applyLocationFilters(): void {
    if (this.areaRestrictedTarget.checked) {
      for (const child of this.areaRestrictedOptionsTargets) child.classList.remove('is-hidden');

      const areaIds = this.suburbRestrictedTarget.checked ? this.areaRestrictedOptionTargets.filter((child) => child.checked).map((child) => child.dataset["areaId"]) : [];

      for (const child of this.suburbRestrictedOptionsTargets) {
        if (child.dataset["areaId"] == undefined || areaIds.includes(child.dataset["areaId"])) {
          child.classList.remove('is-hidden');
        } else {
          child.classList.add('is-hidden');
        }
      }
    } else {
      for (const child of this.areaRestrictedOptionsTargets) child.classList.add('is-hidden');

      this.suburbRestrictedTarget.checked = false;
      for (const child of this.suburbRestrictedOptionsTargets) child.classList.add('is-hidden');
    }
  }
}
